import React from "react";
import { useUsers } from '../UserContext';
import { Link } from "react-router-dom";
import dummyPic from "../blank.png";
import { formatLocation } from "../utils/format";

const locationStyle = {
  fontSize: "18px",
  fontFamily: "Hebrew",
  marginTop: "0px",
};

const bioStyle = {
  fontSize: "12px",
  fontFamily: "Hebrew",
};

export default function Users() {
  const { users, loading } = useUsers();

  return (
    <div>
      <br></br>
      <br></br>
      <h3>The Community</h3>
      {loading && users.length === 0 && <p className="mediumtext">Loading…</p>}
      {users.map((user) => (
        <div className="user" key={user.id}>
          <div>
            <img
              className="user-pic"
              src={user.profile_pic_url || dummyPic}
              alt="user profile"
            ></img>
          </div>
          <div>
            <p className="user-name">
              {user.first_name} {user.last_name}
            </p>
            {formatLocation(user) && (
              <p style={locationStyle}>{formatLocation(user)}</p>
            )}
            <p style={bioStyle}>{user.bio}</p>
            <div className="smallbrownbutton">
              <Link
                className="smallbrownbuttonlink"
                to={`/user/${user.first_name}${user.last_name}`}
              >
                {user.first_name}'s Wall
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
